module.exports = __webpack_public_path__ + "img/dne-market.029a3198.png";